import styled from 'styled-components'

export const OptionLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const OptionLabelCompanyName = styled.div`
  margin-right: 8px;
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const OptionLabelAddress = styled.div`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
